import React from 'react';

export function Star(props) {
    return (
        <svg viewBox="0 0 47 48" {...props}>
            <path
                fillRule="evenodd"
                d="M.837 20.19l10.553 8.07c1.4 1.074 2.137 3.324 1.63 4.987l-3.963 13.1c-.504 1.667.226 2.16 1.623 1.08l10.303-7.93c1.377-1.076 3.67-1.08 5.074-.01l10.393 7.94c1.373 1.08 2.11.584 1.607-1.08l-4.04-13.146c-.504-1.664.213-3.907 1.606-4.977l10.437-8.033c1.4-1.074.977-1.637-.793-1.637H31.84c-1.763 0-2.817-1.673-3.347-3.337L24.377 1.794C23.86.131 23.03.131 22.53 1.801l-4.07 13.41c-.507 1.67-1.627 3.343-3.403 3.343H1.633c-1.78 0-2.193.56-.796 1.637"
            />
        </svg>
    );
}
